import React from 'react';

import { Stack, Typography } from '@mui/material';

import PermissionedComponent from '~/components/Common/PermissionedComponent';

import { ROLE_ADMIN_USER, ROLE_HOTEL_COORDINATOR } from '~/consts/roles';

import RatePlansBulkUpload from './RatePlansBulkUpload';

const fallback = (
  <Stack gap={2}>
    <Typography variant="h4">Permission required</Typography>
    <Typography variant="body2">You are not authorized to view this page</Typography>
  </Stack>
);

export default function RatePlansContainer() {
  return (
    <PermissionedComponent requiredRoles={[ROLE_ADMIN_USER, ROLE_HOTEL_COORDINATOR]} fallback={fallback}>
      <RatePlansBulkUpload />
    </PermissionedComponent>
  );
}
